<header class="flex-row flex-justify-start flex-items-stretch">
  <!--LOGO-->
  <div class="logo-wrapper" [class.show-sidebar]="showSidebar">
    <div *ngIf="showSidebar" class="sidebar-toggle-button-wrapper flex-row flex-items-center flex-justify-center">
      <button
        class="ui icon sidebar-toggle-button"
        [class.active]="!sidebarMinimised"
        [title]="menuIconTitleKey | translate"
        (click)="toggleSidebar()"
      >
        <img src="/assets/header/hamburger.svg" alt="" />
      </button>
    </div>

    <a *ngIf="externalLogoLink" class="logo" [href]="externalLogoLink">
      <gd-store-logo></gd-store-logo>
    </a>
    <a *ngIf="!externalLogoLink" routerLink="/">
      <gd-store-logo></gd-store-logo>
    </a>
  </div>

  <ng-container *ngIf="headerComponent">
    <ng-container *ngComponentOutlet="headerComponent"></ng-container>
  </ng-container>

  <ng-container *ngIf="!headerComponent">
    <!--ACTIONS-->
    <nav class="flex-row flex-justify-end flex-items-center flex-1">
      <gd-header-whats-new></gd-header-whats-new>
      <gd-header-create-menu class="header-create-menu" [isMobile]="false"></gd-header-create-menu>
      <gd-active-client-info
        [userWrapperClass]="userWrapperClass"
        [userInitialsBackgroundLoading]="isBrandingColorsLoading"
      >
      </gd-active-client-info>
    </nav>
  </ng-container>
</header>
